import React from 'react';
import { connect } from 'react-redux';
import { LinearProgress, Typography, Button } from '@mui/material';
import { allLoaded, getChangelogsForBuildings } from '../../redux/selectors/changelogs';
import { ChangelogsLoader } from '../loaders/BuildingsLoader';
import ChangesTable from './ChangesTable';

import './org-building-changelog.css';

/**
 * Changelog table for all buildings in an organization
 */
const OrgBuildingChangelog = ({ buildings, logs, isLoaded, resetFilters }) => {
  if (!isLoaded) {
    return (
      <div className="org-changelogs">
        <ChangelogsLoader key={buildings?.length} buildingIds={buildings} />
        <LinearProgress className="loading" color="secondary" />
      </div>
    );
  }

  if (logs?.length === 0) {
    return (
      <div className="org-changelogs reset">
        <Typography variant="h5">There are no changes that match your filters</Typography>
        <Button
          className="reset-button"
          variant="outlined"
          color="secondary"
          onClick={resetFilters}
        >
          Reset filters
        </Button>
      </div>
    );
  }

  return (
    <div className="org-changelogs">
      <ChangesTable logItems={logs} />
    </div>
  );
};

export default connect((state, { filters, buildings }) => {
  const { date } = filters;
  return {
    isLoaded: buildings.length > 0 && allLoaded(state, buildings),
    logs: getChangelogsForBuildings(state, buildings, date),
  };
})(OrgBuildingChangelog);
